import { lucideIcons } from '../app.js';

export function renderPrivacy(container) {
  container.innerHTML = `
    <div class="landing-header">
      <a class="landing-logo" href="#/drop" style="text-decoration:none;color:var(--text)">
        <svg viewBox="0 0 32 32" width="36" height="36" style="flex-shrink:0"><defs><linearGradient id="bk-priv" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#3ecfb4"/><stop offset="100%" stop-color="#2a9d8f"/></linearGradient></defs><rect width="32" height="32" rx="7" fill="url(#bk-priv)"/><rect x="10" y="14" width="12" height="10" rx="2" fill="#0c0e14"/><path d="M12.5 14V11a3.5 3.5 0 0 1 7 0v3" fill="none" stroke="#0c0e14" stroke-width="2.2" stroke-linecap="round"/><circle cx="16" cy="19" r="1.5" fill="url(#bk-priv)"/><line x1="16" y1="20.5" x2="16" y2="22" stroke="url(#bk-priv)" stroke-width="1.5" stroke-linecap="round"/></svg>
        <div class="brand">Blind<span>Keep</span></div>
      </a>
      <a class="landing-signin" href="#/login">Sign in</a>
    </div>
    <div class="privacy-body">
      <h1 class="privacy-title">Privacy Statement</h1>
      <p class="privacy-updated">Last updated: 11 March 2026</p>

      <section class="privacy-section">
        <h2>The short version</h2>
        <p>BlindKeep does not track you. No analytics, no cookies, no fingerprinting, no advertising, no data sales. Your encrypted data is stored in the EU and we cannot read it.</p>
      </section>

      <section class="privacy-section">
        <h2>No tracking or analytics</h2>
        <ul>
          <li>No analytics scripts (no Google Analytics, Plausible, Mixpanel, or similar)</li>
          <li>No tracking pixels or beacons</li>
          <li>No browser fingerprinting</li>
          <li>No advertising or retargeting</li>
          <li>No A/B testing frameworks</li>
          <li>No telemetry sent to third parties</li>
        </ul>
      </section>

      <section class="privacy-section">
        <h2>No cookies</h2>
        <p>BlindKeep does not set any cookies. Authentication state is held in session storage, which is cleared when you close the tab. No persistent identifiers survive across sessions.</p>
      </section>

      <section class="privacy-section">
        <h2>External resources</h2>
        <p>None. All resources — JavaScript, CSS, fonts, icons, and WASM — are served from our own domain. No CDNs, no third-party scripts, no external requests.</p>
      </section>

      <section class="privacy-section">
        <h2>What we store</h2>
        <p>Because BlindKeep is <a href="#/architecture" class="arch-footer-link" style="font-size:inherit">zero-knowledge</a>, we store only encrypted data and the minimum metadata required to operate the service:</p>
        <table class="arch-table">
          <thead><tr><th>Data</th><th>Purpose</th><th>Can we read it?</th></tr></thead>
          <tbody>
            <tr><td>Email address</td><td>Account identity, recovery, will notifications</td><td>Yes</td></tr>
            <tr><td>Encrypted blobs (S3)</td><td>Your vault items, files, drops</td><td>No</td></tr>
            <tr><td>Wrapped keys</td><td>Key management</td><td>No</td></tr>
            <tr><td>File size (bytes)</td><td>Billing and metering</td><td>Yes (padded to size buckets)</td></tr>
            <tr><td>Timestamps</td><td>Record ordering, expiry logic</td><td>Yes</td></tr>
            <tr><td>IP addresses</td><td>Rate limiting, audit log</td><td>Yes</td></tr>
            <tr><td>Item/grant/drop counts</td><td>Database row counts</td><td>Yes</td></tr>
          </tbody>
        </table>
        <p>We cannot decrypt your files, notes, passwords, or any vault content. See the <a href="#/architecture" class="arch-footer-link" style="font-size:inherit">cryptographic architecture</a> for the full technical proof.</p>
      </section>

      <section class="privacy-section">
        <h2>Data location</h2>
        <p>All data is stored and processed in <strong>European data centres</strong> (Scaleway, France). The server runs in the EU. Your data does not leave Europe.</p>
      </section>

      <section class="privacy-section">
        <h2>Data retention</h2>
        <ul>
          <li><strong>Vault items:</strong> Stored until you delete them or close your account</li>
          <li><strong>Drops:</strong> Auto-deleted 60 minutes after creation</li>
          <li><strong>Grants:</strong> Stored until revoked by the grantor or expired per policy</li>
          <li><strong>Audit logs:</strong> Retained for your review; deleted with your account</li>
          <li><strong>Account deletion:</strong> Removes all associated data (items, keys, grants, wills, audit logs)</li>
        </ul>
      </section>

      <section class="privacy-section">
        <h2>Third-party data sharing</h2>
        <p>We do not sell, rent, or share your data with any third party. We do not have advertisers, data brokers, or analytics partners. Payment processing (Stripe) receives only the minimum billing data required to process a transaction — never your vault content.</p>
      </section>

      <section class="privacy-section">
        <h2>Law enforcement</h2>
        <p>If compelled by valid legal process, we can only provide what we have: encrypted blobs, email addresses, timestamps, and IP addresses. We cannot provide decryption keys or plaintext data because we do not have them. This is a property of the architecture, not a policy choice.</p>
      </section>

      <section class="privacy-section">
        <h2>Contact</h2>
        <p>Questions about privacy? Email <strong>privacy@blindkeep.com</strong></p>
      </section>
    </div>
    <div class="landing-footer"><a href="#/architecture" class="arch-footer-link">End-to-end encrypted</a> &middot; <a href="#/architecture" class="arch-footer-link">Zero knowledge</a> &middot; <a href="#/privacy" class="arch-footer-link">No tracking</a> &middot; <a href="#/compare" class="arch-footer-link">Compare</a> &middot; <a href="#/faq" class="arch-footer-link">FAQ</a></div>
    <div class="eu-badge">\u{1F1EA}\u{1F1FA} Made &amp; operated in the EU</div>
  `;
  lucideIcons();
}
